import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import { Container, Typography, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import BrandLogo from '../../components/BrandLogo';
import { supabase } from '../../supabaseClient.js';
import { seedDefaultTemplates } from '../../utils/seedDefaultTemplates.js';
import { useDispatch } from 'react-redux';
import { resetGlobalState } from '../../store.js';

const EmailVerify = () => {
  const [userid, setUserId] = useState('');
  const [userMetadata, setUserMetadata] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [isExistingUser, setIsExistingUser] = useState(false); // Added state
  const navigate = useNavigate();
  const dispatch = useDispatch();

  React.useEffect(() => {
    verifyUser();
  }, []);

  // The verify link lands here with tokens in the URL hash; supabase-js
  // exchanges them asynchronously, so an immediate getUser() can race the
  // exchange and report "no session" for a user who just verified. Wait for
  // the session instead of bailing to '/'.
  const waitForUser = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.user) return session.user;
    return new Promise((resolve) => {
      const timer = setTimeout(() => {
        subscription.unsubscribe();
        resolve(null);
      }, 8000);
      const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, newSession) => {
        if (newSession?.user) {
          clearTimeout(timer);
          subscription.unsubscribe();
          resolve(newSession.user);
        }
      });
    });
  };

  const verifyUser = async () => {
    const user = await waitForUser();
    if (!user) {
      navigate('/');
      return;
    }

    if (user.email_confirmed_at) {
      setUserId(user.id);
      const userMetadata = user.user_metadata || null;
      setUserEmail(user.email);
      setUserMetadata(userMetadata?.userData);

      // The profile row is created by the on_auth_user_created DB trigger at
      // signup, so its presence no longer distinguishes new from returning
      // users — onboarding_step does (NULL = finished onboarding).
      const { data: profile } = await supabase
        .from('user_accounts')
        .select('onboarding_step')
        .eq('id', user.id)
        .maybeSingle();

      if (profile && profile.onboarding_step === null) {
        setIsExistingUser(true);
        setTimeout(() => {
            navigate('/login');
        }, 2000);
      }
      else {
        await seedDefaultTemplates(user.id);
        // Keep the verified session signed in: onboarding continues under
        // it. Only clear any stale persisted UI state from a previous account.
        dispatch(resetGlobalState());
      }
    }
  };

  return (
    <Container disableGutters maxWidth={false}> 
      <Grid container spacing={2} sx={{ minHeight: '100vh', minWidth: '100vw', marginTop: -3 }}>
        <Grid size={12} sx={{ backgroundColor: '#B9F4F2', height: '90px', padding: '15px 10px 0px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <BrandLogo  />
        </Grid>
        <Grid size={12} sx={{display: 'flex', alignItems: 'flex-start', justifyContent: 'center'}}>
            <Stack spacing={3} width={{xs: '80vw', md: '40vw'}} direction="column" alignItems="flex-start" justifyContent="center" style={{backgroundColor: '#f5f5f5', padding: '30px', borderRadius: '10px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)' }}>
            
            {isExistingUser ? (
                <Typography variant="h6" sx={{fontWeight: 'bold', fontSize: '20px'}}>
                  Email already verified previously. Redirecting to application...
                </Typography>
            ) : (
                <Typography variant="h6" sx={{fontWeight: 'bold', fontSize: '30px'}}>
                  Email has been verified successfully. Please click <span onClick={() => { navigate('/onboarding') }} style={{ cursor: 'pointer', color: '#29C0BB' }}>here</span> to set up your account and complete the signup process.
                </Typography>
            )}

            </Stack>
        </Grid> 
      </Grid>
    </Container>
  );
};

export default EmailVerify;